export default {
  bind(el) {
    const dialogEl = el.querySelector('.el-dialog')
    const headerEl = el.querySelector('.el-dialog__header')
    if (!dialogEl || !headerEl) return

    headerEl.style.cursor = 'move'

    const mouseDownHandler = (e) => {
      // 记录鼠标按下时的坐标
      const startX = e.clientX
      const startY = e.clientY

      // 记录弹窗当前的 transform
      const startTransform = dialogEl.style.transform || 'translate(0,0)'

      const mouseMoveHandler = (e) => {
        // 计算相对位移
        const dx = e.clientX - startX
        const dy = e.clientY - startY

        // 叠加位移（保留原有 transform）
        dialogEl.style.transform = `${startTransform} translate(${dx}px, ${dy}px)`

        e.preventDefault()
      }

      const mouseUpHandler = () => {
        // 拖拽结束后，将 transform 转为 left/top
        const matrix = new DOMMatrix(dialogEl.style.transform)
        dialogEl.style.left = `${parseInt(dialogEl.style.left || '0') + matrix.e}px`
        dialogEl.style.top = `${parseInt(dialogEl.style.top || '0') + matrix.f}px`
        dialogEl.style.transform = 'translate(0,0)'

        document.removeEventListener('mousemove', mouseMoveHandler)
        document.removeEventListener('mouseup', mouseUpHandler)
      }

      document.addEventListener('mousemove', mouseMoveHandler)
      document.addEventListener('mouseup', mouseUpHandler)
      e.preventDefault()
    }

    headerEl.addEventListener('mousedown', mouseDownHandler)

    el.__dragUnbind__ = () => {
      headerEl.removeEventListener('mousedown', mouseDownHandler)
    }
  },
  unbind(el) {
    if (el.__dragUnbind__) {
      el.__dragUnbind__()
      delete el.__dragUnbind__
    }
  },
}
